// DO NOT EDIT -- generated from fs/services/orgs/embed_partners.proto

import { EmbedPartner, Role } from './model.proto';
import * as protobuf from '../../../google/protobuf';

/**
 * //////////////////////////
 * public API (through gangplank) entry point for Alpha
 * //////////////////////////
 */
export namespace EmbedPartners {

  export const CreateEmbedOrgEndpoint = "/grpc/orgs.EmbedPartners/CreateEmbedOrg";
  /**
   * CreateEmbedOrg creates a new Embed-only org under the requesting Embed Partner.
   * Intended to be called by Embed Partners.
   */
  export function CreateEmbedOrg(sender: (req: CreateEmbedOrgRequest, endpoint: string) => Promise<CreateEmbedOrgResponse>, req: CreateEmbedOrgRequest): { promise: () => Promise<CreateEmbedOrgResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateEmbedOrgEndpoint),
      endpoint: CreateEmbedOrgEndpoint
    };
  }

  export const UpdateEmbedOrgEndpoint = "/grpc/orgs.EmbedPartners/UpdateEmbedOrg";
  /**
   * UpdateEmbedOrg updates an existing Embed-only org under the requesting Embed Partner.
   * Intended to be called by Embed Partners.
   */
  export function UpdateEmbedOrg(sender: (req: UpdateEmbedOrgRequest, endpoint: string) => Promise<{}>, req: UpdateEmbedOrgRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateEmbedOrgEndpoint),
      endpoint: UpdateEmbedOrgEndpoint
    };
  }

  export const CreateEmbedOrgSeatEndpoint = "/grpc/orgs.EmbedPartners/CreateEmbedOrgSeat";
  /**
   * CreateEmbedOrgSeat creates a new seat under the given Embed-only org.
   * Intended to be called by Embed Partners.
   */
  export function CreateEmbedOrgSeat(sender: (req: CreateEmbedOrgSeatRequest, endpoint: string) => Promise<{}>, req: CreateEmbedOrgSeatRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CreateEmbedOrgSeatEndpoint),
      endpoint: CreateEmbedOrgSeatEndpoint
    };
  }

  export const DeleteEmbedOrgSeatEndpoint = "/grpc/orgs.EmbedPartners/DeleteEmbedOrgSeat";
  /**
   * DeleteEmbedOrgSeat deletes an existing seat under the given Embed-only org.
   * Intended to be called by Embed Partners.
   */
  export function DeleteEmbedOrgSeat(sender: (req: DeleteEmbedOrgSeatRequest, endpoint: string) => Promise<{}>, req: DeleteEmbedOrgSeatRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteEmbedOrgSeatEndpoint),
      endpoint: DeleteEmbedOrgSeatEndpoint
    };
  }

  export const CreateEmbedPartnerEndpoint = "/grpc/orgs.EmbedPartners/CreateEmbedPartner";
  /** CreateEmbedPartner creates a new Embed Partner. Intended to be called through gRPCui for Embed alpha. */
  export function CreateEmbedPartner(sender: (req: CreateEmbedPartnerRequest, endpoint: string) => Promise<CreateEmbedPartnerResponse>, req: CreateEmbedPartnerRequest): { promise: () => Promise<CreateEmbedPartnerResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateEmbedPartnerEndpoint),
      endpoint: CreateEmbedPartnerEndpoint
    };
  }

  export const GetEmbedPartnerEndpoint = "/grpc/orgs.EmbedPartners/GetEmbedPartner";
  /** GetEmbedPartner returns a single Embed Partner. Intended to be called through gRPCui for Embed alpha. */
  export function GetEmbedPartner(sender: (req: GetEmbedPartnerRequest, endpoint: string) => Promise<EmbedPartner>, req: GetEmbedPartnerRequest): { promise: () => Promise<EmbedPartner>, endpoint: string } {
    return {
      promise: () => sender(req, GetEmbedPartnerEndpoint),
      endpoint: GetEmbedPartnerEndpoint
    };
  }

  export const ListEmbedPartnersEndpoint = "/grpc/orgs.EmbedPartners/ListEmbedPartners";
  /** ListEmbedPartners returns all Embed Partners. Intended to be called through gRPCui for Embed alpha. */
  export function ListEmbedPartners(sender: (req: {}, endpoint: string) => Promise<ListEmbedPartnersResponse>, req: {}): { promise: () => Promise<ListEmbedPartnersResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListEmbedPartnersEndpoint),
      endpoint: ListEmbedPartnersEndpoint
    };
  }
}

export interface CreateEmbedOrgRequest {
  embedPartnerId: string;
  orgName: string;
  orgCreatorEmail: string;
  /** Will be capped at 30 million for Embed alpha */
  orgSessions: protobuf.int64;
  /** Optional */
  orgCreatorFirstName: string;
  /** Optional */
  orgCreatorLastName: string;
}

export interface CreateEmbedOrgResponse {
  orgId: string;
}

export interface UpdateEmbedOrgRequest {
  embedPartnerId: string;
  orgId: string;
  orgName: string;
  /** Will be capped at 30 million for Embed alpha */
  orgSessions: protobuf.int64 | null;
}

export interface CreateEmbedOrgSeatRequest {
  embedPartnerId: string;
  orgId: string;
  email: string;
  role: Role;
}

export interface DeleteEmbedOrgSeatRequest {
  embedPartnerId: string;
  orgId: string;
  email: string;
}

export interface CreateEmbedPartnerRequest {
  embedPartnerName: string;
  creatorEmail: string;
  /** Optional */
  creatorFirstName: string;
  /** Optional */
  creatorLastName: string;
}

export interface CreateEmbedPartnerResponse {
  embedPartnerId: string;
}

export interface GetEmbedPartnerRequest {
  embedPartnerId: string;
}

export interface ListEmbedPartnersResponse {
  partners: EmbedPartner[];
}
